import React, { useCallback } from 'react'
import { ModelForm, hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withForm = Component => props => {
  const { vehicletype_id } = hooks.useParams()
  const locale = hooks.useLocale()

  const formProps = {
    name: 'vehicletype_form',
    model_name: 'vehicletype',
    record_id: vehicletype_id,
    populate: ['name_trkey'],
    initialState: { isReadOnly: !!vehicletype_id },
    recordToForm: useCallback(Callbacks.recordToFormHandler(), []),
    formToRecord: useCallback(Callbacks.formToRecordHandler(), []),
    recordToState: useCallback(Callbacks.recordToStateHandler(locale), [locale])
  }

  const mergedProps = {
  }

  return (
    <ModelForm {...formProps}>
      <Component {...mergedProps} />
    </ModelForm>
  )
}

export default withForm
